













import { Component, Vue, Prop } from "vue-property-decorator";

import { Item } from '../types';

@Component({
components: {}
})
export default class VoteItem extends Vue {
@Prop() item!: Item;
@Prop() voteId!: string;
@Prop() value!: string | null;
@Prop() showResult!: boolean;

public select() {
  this.$emit('input', this.item.id);
}

}
